import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SimpleBannerItem from 'core/modules/SimpleBannerList/components/SimpleBannerItem/SimpleBannerItem';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import { useGetMarketingBanner } from './hooks';
import { triggerMarketingBannerIsViewed } from './actions';

import './MarketingBanner.scss';

export function MarketingBanner() {
  const dispatch = useDispatch();
  const { bannerPlacementsToShow, config } = useGetMarketingBanner();

  const { api: { params: { content_group_id: contentGroupId } } } = config;

  useEffect(() => {
    bannerPlacementsToShow.forEach((placement) => dispatch(triggerMarketingBannerIsViewed(placement, contentGroupId)));
  }, [bannerPlacementsToShow]);

  if (isEmpty(bannerPlacementsToShow)) {
    return (null);
  }

  return (
    <div className="mn_marketingBanner">
      <ContentWrap>
        {bannerPlacementsToShow.map((placement) => (
          <SimpleBannerItem dataItem={placement} contentGroupId={contentGroupId} key={placement.id} />
        ))}
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><MarketingBanner {...props} /></ComponentErrorBoundary>;
